import { brandHome } from './brandHomeTokens';
import { tokens } from '../../theme/tokens';
import type { StatusTone } from '../../components/ui';

export type Severity = 'blocking' | 'warning' | 'info' | 'positive';

export interface SeverityTone {
  dot: string;
  bg: string;
  border: string;
  ink: string;
}

/** One severity system backs the attention queue, rebate/MAP chips, and store health tints. */
export const SEVERITY_TONES: Record<Severity, SeverityTone> = {
  blocking: {
    dot: brandHome.color.problemSolid,
    bg: brandHome.color.problemTint,
    border: brandHome.color.problemBorder,
    ink: brandHome.color.problemInk,
  },
  warning: {
    dot: brandHome.color.cautionSolid,
    bg: brandHome.color.cautionTint,
    border: brandHome.color.cautionBorder,
    ink: brandHome.color.cautionInk,
  },
  info: {
    dot: brandHome.color.infoSolid,
    bg: brandHome.color.infoTint,
    border: brandHome.color.infoBorder,
    ink: brandHome.color.infoInk,
  },
  positive: {
    dot: brandHome.color.positiveSolid,
    bg: brandHome.color.positiveTint,
    border: brandHome.color.positiveBorder,
    ink: brandHome.color.positiveInk,
  },
};

/** Row tints are lighter than the chip tints above. */
export const SEVERITY_ROW_TINTS: Record<'blocking' | 'warning', string> = {
  blocking: tokens.signal.problem.row,
  warning: tokens.signal.caution.row,
};

/** Maps a severity onto the shared `StatusChip` tone vocabulary. */
export const severityToTone = (severity: Severity): StatusTone => {
  if (severity === 'blocking') return 'problem';
  if (severity === 'warning') return 'caution';
  return severity;
};
